import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';

import LeftPanel from '@/components/auth/left-panel';
import { Button } from '@/components/ui/button';

export default function PasswordUpdatedPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  if (!location.state?.confirmed) {
    return <Navigate to='/login' replace />;
  }

  return (
    <div className='flex min-h-screen bg-ws-bg'>
      <LeftPanel />

      <div className='flex flex-1 items-center justify-center px-6'>
        <div className='w-full max-w-[320px] space-y-8 text-center'>
          {/* Header */}
          <div className='space-y-2'>
            <h1 className='text-3xl font-semibold text-ws-text'>
              {t('auth.passwordUpdated.title')}
            </h1>
            <p className='text-base text-ws-muted'>
              {t('auth.passwordUpdated.subtitle')}
            </p>
          </div>

          {/* Actions */}
          <Button variant='primary' size='lg' block onClick={() => navigate('/login')}>
            {t('auth.passwordUpdated.login')}
          </Button>
        </div>
      </div>
    </div>
  );
}
